import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./components/pages/HomePage";
import RoomPage from "./components/pages/RoomPage";
import GamePage from "./components/pages/GamePage";
import DebugPage from "./components/debug/DebugPage";
import NotFoundPage from "./components/pages/NotFoundPage";
import { SocketProvider } from "./context/SocketContext";
import { GameProvider } from "./context/GameContext";
import ImagePreloader from "./components/utils/ImagePreloader";

const App: React.FC = () => {
  // Only show debug route in development
  const isDevelopment = process.env.NODE_ENV === "development";

  return (
    <SocketProvider>
      <GameProvider>
        <ImagePreloader>
          <div className="min-h-screen bg-slate-900 text-white">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/room/:roomId" element={<RoomPage />} />
              <Route path="/game/:roomId" element={<GamePage />} />
              {isDevelopment && <Route path="/debug" element={<DebugPage />} />}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
        </ImagePreloader>
      </GameProvider>
    </SocketProvider>
  );
};

export default App;
